export class Fonts {

}
